export default __webpack_public_path__ + "static/media/unit-updated.6fb0e264.svg";